import { useTransformContext } from 'react-zoom-pan-pinch';
import { useEffect } from 'react';
import { useDragAndDrop } from '../../provider/drag-and-drop/DragAndDrop.hook.ts';

export const useTechnicalController = () => {
  const { state } = useTransformContext();
  const { setTransformState } = useDragAndDrop();

  useEffect(() => {
    setTransformState(state);
  }, [setTransformState, state]);
};
